import { useTranslation } from 'react-i18next'

import {
  UnityHubCreateChannelsMainStep,
  TUnityHubCreateChannelsMainStepProps
} from 'App/components/UnityHub'

import {
  useCommunityCreateChannelMainStepRequest,
  TUseCommunityCreateChannelMainStepRequest
} from './useCommunityCreateChannelMainStepRequest'

export type TCommunityCreateChannelMainStepProps = Pick<
  TUnityHubCreateChannelsMainStepProps,
  | 'channelManagers'
  | 'isEdit'
  | 'loading'
  | 'name'
  | 'setName'
  | 'isPublic'
  | 'setIsPublic'
  | 'onOpenMembers'
  | 'channelMembers'
  | 'onOpenChanelManager'
  | 'dirty'
  | 'initialValues'
> &
  Pick<
    TUseCommunityCreateChannelMainStepRequest,
    'variant' | 'communityId' | 'channelId' | 'onEditSuccess'
  >

export const CommunityCreateChannelMainStep = ({
  channelMembers,
  communityId,
  channelManagers,
  channelId,
  name,
  isEdit,
  variant,
  loading,
  dirty,
  setName,
  isPublic,
  setIsPublic,
  onOpenChanelManager,
  onOpenMembers,
  onEditSuccess,
  initialValues
}: TCommunityCreateChannelMainStepProps) => {
  const { t } = useTranslation()

  const { error, isFieldError, processing, isBusinessAccount, handleFormSubmit } =
    useCommunityCreateChannelMainStepRequest({
      communityId,
      channelId,
      channelMembers,
      channelManagers,
      isEdit,
      variant,
      onEditSuccess
    })

  const shouldShowAlert = variant === 'news' && !isEdit

  return (
    <UnityHubCreateChannelsMainStep
      dirty={dirty}
      isEdit={isEdit}
      name={name}
      channelMembers={channelMembers}
      channelManagers={channelManagers}
      showAlert={shouldShowAlert}
      alert={t('modal.createChannel.alert_news')}
      setName={setName}
      onFormSubmit={handleFormSubmit}
      onOpenChanelManager={onOpenChanelManager}
      onOpenMembers={onOpenMembers}
      loading={loading}
      isFieldError={isFieldError}
      error={error}
      isPublic={isPublic}
      setIsPublic={setIsPublic}
      processing={processing}
      selectManagerDisabled={!isBusinessAccount}
      initialValues={initialValues}
    />
  )
}
